import { useCallback } from "react"
import { toast as sonnerToast } from "sonner"

type ToastVariant = "default" | "destructive" | "success"

interface ToastOptions {
  title?: string
  description?: string
  variant?: ToastVariant
}

// Shadcn/Sonner-based toast hook
export function useToast() {
  const toast = useCallback((options: ToastOptions) => {
    const { title, description, variant = "default" } = options
    const message = title || description
    const subtitle = title && description ? description : undefined

    switch (variant) {
      case "destructive":
        sonnerToast.error(message, { description: subtitle })
        break
      case "success":
        sonnerToast.success(message, { description: subtitle })
        break
      default:
        sonnerToast(message, { description: subtitle })
        break
    }
  }, [])

  return { toast }
}
